/**
 * OPTIONAL FORM ELEMENTS
 */
const placeholder = {
    type: 'text',
    name: 'config.placeholder',
    label: 'Placeholder',
    validation: {},
    attributes: {
        placeholder: ''
    },
    config_field: true
};

const validation = {
    type: 'validation-config',
    name: 'validation',
    label: 'Validation rules'
};

const options_single = {
    type: 'key-value',
    name: 'config.options',
    label: 'Options',
    validation: {},
    config: {
        single: true,
        options: []
    },
    attributes: {
        placeholder: ''
    },
    config_field: true
};

const options_multi = {
    type: 'key-value',
    name: 'config.options',
    label: 'Options',
    validation: {},
    config: {
        single: false
    },
    attributes: {
        placeholder: ''
    },
    config_field: true
};

const permissions = {
    type: 'permissions',
    name: 'roles_permissions',
    label: 'Permissions'
};

const media_upload_type = {
    type: 'select',
    name: 'config.upload_type',
    label: 'Upload type',
    validation: {
        required: true
    },
    config: {
        options: [
            {id: 'file', text: 'File(s)'},
            {id: 'image', text: 'Images'}
        ]
    },
    attributes: {
        placeholder: ''
    },
    config_field: true
};

const media_upload_multi = {
    type: 'radio',
    name: 'config.upload_multi',
    label: 'Enable multiple file/image upload?',
    validation: {
        required: true
    },
    config: {
        options: [{
            value: false,
            text: 'No',
            default: true
        }, {
            value: true,
            text: 'Yes'
        }]
    },
    attributes: {
        checked: false
    },
    config_field: true
};

/**
 * DEFAULT FORM ELEMENTS -> USED IN CHASSIS FORMS
 *
 * @type {[{label: string; icon: string; type: string; validation: {}; settings: {available_validations: [string,string,string]; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {email: boolean}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {url: boolean}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: [string,string,string]; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string; validation: {}; options: {single: boolean; options: Array}; attributes: {placeholder: string}; config_field: boolean},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string; validation: {}; options: {single: boolean}; attributes: {placeholder: string}; config_field: boolean},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {}; attributes: {placeholder: string}},{type: string; name: string; label: string; validation: {}; options: {single: boolean; options: Array}; attributes: {placeholder: string}; config_field: boolean},{type: string; name: string; label: string}]}},{label: string; icon: string; type: string; validation: {}; settings: {available_validations: Array; extra_fields: [{type: string; name: string; label: string; validation: {required: boolean}; options: {options: {id: string; text: string}[]}; attributes: {placeholder: string}; config_field: boolean},{type: string; name: string; label: string; validation: {required: boolean}; options: {options: ({value: boolean; text: string; default: boolean}|{value: boolean; text: string})[]}; attributes: {checked: boolean}; config_field: boolean},{type: string; name: string; label: string}]}}]}
 */
export const DefaultElements = [
    {
        label: 'text',
        icon: 'fa fa-font',
        type: 'text',
        validation: {},
        settings: {
            available_validations: ['required', 'minlength', 'maxlength'],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'textarea',
        icon: 'fa fa-align-center',
        type: 'textarea',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'email',
        icon: 'fa fa-at',
        type: 'email',
        validation: {
            email: true
        },
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'password',
        icon: 'fa fa-key',
        type: 'password',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, permissions]
        }
    },
    {
        label: 'number',
        icon: 'fa fa-sort-numeric-asc',
        type: 'number',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'currency',
        icon: 'fa fa-euro',
        type: 'currency',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'url',
        icon: 'fa fa-link',
        type: 'url',
        validation: {
            url: true
        },
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'datepicker',
        icon: 'fa fa-calendar',
        type: 'date',
        validation: {},
        settings: {
            available_validations: ['required', 'minDate', 'maxDate'],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'timepicker',
        icon: 'fa fa-clock-o',
        type: 'time',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, validation, permissions]
        }
    },
    {
        label: 'selectbox',
        icon: 'fa fa-caret-square-o-down',
        type: 'select',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, options_single, permissions]
        }
    },
    {
        label: 'multiple options',
        icon: 'fa fa-check-square-o',
        type: 'checkbox',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, options_multi, permissions]
        }
    },
    {
        label: 'single option',
        icon: 'fa fa-check-circle-o',
        type: 'radio',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [placeholder, options_single, permissions]
        }
    },
    {
        label: 'media upload',
        icon: 'fa fa-upload',
        type: 'media',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [media_upload_type, media_upload_multi, permissions]
        }
    },
    {
        label: 'Tree selection',
        icon: 'fa fa-sitemap',
        type: 'tree',
        validation: {},
        settings: {
            available_validations: [],
            extra_fields: [permissions]
        }
    }
];


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/entities/config/elements.ts